<template>
  <div class="app-row"
       :class="[{
         'app-row_no-gutters-y': noGuttersY
       }]"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: "AppRow",
    props: {
      noGuttersY: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
.app-row{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;

  &_no-gutters-y{
    &>.app-col{
      padding-top: 0!important;
      padding-bottom: 0!important;
    }
  }
}
</style>